<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top" style="display: block">
          <template>
            <el-input
                clearable
                v-model="search.name"
                class="input_search"
                placeholder="搜索题目名称"
                style="margin-bottom: 10px;margin-right: 10px"
                @keyup.enter.native="SearchServiceList"
            ></el-input>

            <el-select
                v-model="search.categoryId"
                clearable
                filterable
                placeholder="选择分类"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              ></el-option>
            </el-select>

            <el-select
                v-model="search.isOffline"
                clearable
                filterable
                placeholder="题目状态"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in QUESTION_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>

            <el-select
                v-model="search.answerWay"
                clearable
                filterable
                placeholder="答题方式"
                style="margin-bottom: 10px;margin-right: 10px"
            >
              <el-option
                  v-for="item in ANSWER_WAY"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>

            <el-button size="medium" type="primary" @click="SearchServiceList"
            >查询</el-button
            >
            <el-button size="medium" @click="handleReset"
            >重置</el-button
            >
          </template>
          <el-button v-if="addShow" size="medium" type="primary" @click="handleAdd"
          >新增题目</el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column fixed label="序号" type="index" width="80">
              <template slot-scope="scope">
                <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="题目信息" min-width="350">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; text-align: left;">
                  <div style="width: 40px; height: 40px; margin-right: 10px; flex-shrink: 0;" v-if="scope.row.icon">
                    <img 
                      :src="scope.row.icon" 
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;"
                    />
                  </div>
                  <div style="flex: 1;">
                    <div class="ellipsis-multiline" style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                      {{ scope.row.name || '-' }}
                    </div>
                    <div class="ellipsis-multiline" v-html="scope.row.content || '-'" style="color: #666; font-size: 12px;align-self: auto;">
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="答案数" prop="answerNum" width="80"></el-table-column>
            <el-table-column label="分类信息" width="120">
              <template slot-scope="scope">
                <div>{{ scope.row.categoryName || '-' }}</div>
              </template>
            </el-table-column>

            <el-table-column label="展示日期" width="120">
              <template slot-scope="scope">
                <div>{{ formatShowDate(scope.row.showDate) }}</div>
              </template>
            </el-table-column>

            <el-table-column label="布局视图" width="100">
              <template slot-scope="scope">
                <el-tag :type="getViewTag(scope.row.view)" size="mini">
                  {{ getViewText(scope.row.view) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="答题方式" width="100">
              <template slot-scope="scope">
                <el-tag :type="getAnswerWayTag(scope.row.answerWay)" size="mini">
                  {{ getAnswerWayText(scope.row.answerWay) }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="排序" width="100" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.sortOrder"
                  type="number"
                  valueKey="sortOrder"
                  customApi="/question/info/save"
                  :disabled="!editShow"
                  :params="scope.row"
                  @refresh="getQuestionList"
                />
              </template>
            </el-table-column>
            <el-table-column label="上架" width="80" align="center">
              <template slot-scope="scope">
                <InlineTableControler
                  v-model="scope.row.isOffline"
                  valueKey="isOffline"
                  customApi="/question/info/save"
                  :active-value="0"
                  :inactive-value="1"
                  activeColor="#13ce66"
                  inactiveColor="#ff4949"
                  :disabled="!statusShow"
                  :params="scope.row"
                  @refresh="getQuestionList"
                />
              </template>
            </el-table-column>

            <el-table-column label="时间信息" min-width="180">
              <template slot-scope="scope">
                <div style="font-size: 12px;">
                  <div>创建：{{ formatDate(scope.row.ctime) }}</div>
                  <div>更新：{{ formatDate(scope.row.utime) }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  v-if="editShow"
                >
                  编辑
                </el-button>

                <el-button
                  @click="handleDetail(scope.row)"
                  type="text"
                  size="small"
                  v-if="detailShow"
                >
                  详情
                </el-button>

                <el-button
                  @click="handleViewAnswers(scope.row)"
                  type="text"
                  size="small"
                  style="color: #409EFF"
                  v-if="answerShow"
                >
                  答案
                </el-button>

                <el-button
                  @click="handleDelete(scope.row)"
                  type="text"
                  size="small"
                  style="color: #f56c6c"
                  v-if="deleteShow"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <MultiLanguageDetailDialog
      ref="detailDialog"
      title="题目详情"
      width="1000px"
      :detail-api-template="'/question/info/detail/{id}'"
      :answer-api="'/question/answer/list'"
      :multi-language-fields="['name', 'description']"
      :answer-format-function="formatAnswersListHTML"
    />

    <!-- 编辑弹窗 -->
    <MultiLanguageEditDialogDay
      ref="editDialog"
      title="题目编辑"
      width="1000px"
      :fullscreen="false"
      :api="'/question/info/save'"
      :detail-api="'/question/info/detail'"
      @success="getQuestionList"
    />

    <!-- 答案弹窗 -->
    <AnswerPanel ref="answerPanel"/>

  </section>
</template>
<script>
import {
  PAGE_SIZE,
} from "@/config";
import { formatDate } from "@/utils/filters/filter";
import MultiLanguageDetailDialog from "@/components/MultiLanguageDetailDialog.vue";
import MultiLanguageEditDialogDay from '@/components/MultiLanguageEditDialogDay.vue';
import AnswerPanel from './answerPanel.vue';
import InlineTableControler from '@/components/InlineTableControler.vue';
export default {
  components: {
    MultiLanguageDetailDialog,
    MultiLanguageEditDialogDay,
    InlineTableControler,
    AnswerPanel
  },
  data() {
    return {
      PAGE_SIZE,
      formatDate,
      
      // 题目状态选项
      QUESTION_STATUS: [
        { key: 0, name: '上架' },
        { key: 1, name: '下架' }
      ],
      
      // 答题方式选项
      ANSWER_WAY: [
        { key: 'sel1', name: '单选' },
        { key: 'sel2', name: '多选' },
        { key: 'gap', name: '填空题' }
      ],

      // 布局视图选项
      VIEW_TYPE: [
        { key: 've1', name: '列表形' },
        { key: 've2', name: '田字形' }
      ],

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
        count: 0
      },
      
      categoryList: [], // 分类列表
      tableData: [], // 题目列表数据
      loading: false,
      search: {},

      // 权限控制
      searchShow: true,
      addShow: true,
      editShow: true,
      deleteShow: true,
      statusShow: true,
      detailShow: true,
      answerShow: true,

      // 多语言相关
      languageList: [],
      currentLanguageCode: 'en'
    };
  },
  async created() {
    this.getLanguageList();
    this.getPermissionButtonList();
    this.getCategoryList();
    this.getQuestionList();
    
    
  },
  methods: {
    // 获取分类列表
    async getCategoryList() {
      try {
        const { data: res } = await this.$post(
          `/question/category/list`,
          { 
            pageNo: 1, 
            pageSize: 1000
          }
        );
        if (res && res.data) {
          this.categoryList = res.data.records || res.data;
        }
      } catch (error) {
        console.error('获取分类列表失败:', error);
      }
    },

    // 获取语言列表
    async getLanguageList() {
      try {
        const { data: res } = await this.$post('/language/list', {
          adminStatus: 1
        });
        
        if (res && res.data) {
          this.languageList = res.data;
          this.currentLanguageCode = (res.data[0] && res.data[0].code) || 'en';
        }
      } catch (error) {
        console.error('获取语言列表失败:', error);
      }
    },

    // 获取权限按钮列表
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton');
      if (PermissionButtonList) {
        try {
          let arr = JSON.parse(PermissionButtonList);
          if (arr && Array.isArray(arr) && arr.length) {
            arr.forEach(item => {
              if (item.code === 'question:management:query') {
                this.searchShow = true;
              }
              if (item.code === 'question:management:add') {
                this.addShow = true;
              }
              if (item.code === 'question:management:edit') {
                this.editShow = true;
              }
              if (item.code === 'question:management:delete') {
                this.deleteShow = true;
              }
              if (item.code === 'question:management:status') {
                this.statusShow = true;
              }
              if (item.code === 'question:management:detail') {
                this.detailShow = true;
              }
              if (item.code === 'question:management:answer') {
                this.answerShow = true;
              }
            });
          }
        } catch (error) {
          console.error('权限按钮列表解析失败:', error);
        }
      }
    },

    // 搜索
    SearchServiceList() {
      this.page.pageNo = 1;
      this.getQuestionList();
    },

    // 获取题目列表
    async getQuestionList() {
      this.loading = true;
      try {
        const { data: res } = await this.$post(
          `/question/info/list`,
          { 
            ...this.search, 
            pageNo: this.page.pageNo,
            pageSize: this.page.pageSize
          },
          {
            headers: {
              isLoading: true,
              "Language-Code": "HK"
            },
          }
        );
        
        if (res && res.data) {
          this.tableData = res.data.records || res.data||[];
          this.page.count = res.page.count || 0;
        }else{
          this.tableData = [];
          this.page.count = 0;
        }
      } catch (error) {
        console.error('获取题目列表失败:', error);
        this.$message.error('获取题目列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 新增题目
    handleAdd() {
      if (!this.$refs.editDialog) return;
      this.$refs.editDialog.open({}, this.getBasicColumns(), { 
        api: '/question/info/save', 
        method: 'post',
      });
    },

    // 编辑题目
    async handleEdit(row) {
      if (!this.$refs.editDialog) return;
      const editData = {
        ...row,
        categoryId: row.categoryId ? Number(row.categoryId) : this.getCategoryIdByName(row.categoryName)
      };
      this.$refs.editDialog.open(editData, this.getBasicColumns(), { 
        api: '/question/info/save', 
        method: 'post',
      });
    },

    // 根据分类名称获取分类ID
    getCategoryIdByName(categoryName) {
      if (!categoryName || !this.categoryList) return null;
      const category = this.categoryList.find(cat => cat.name === categoryName);
      return category ? category.id : null;
    },

    // 查看详情
    async handleDetail(row) {
      // 检查ref是否存在
      if (!this.$refs.detailDialog) {
        console.error('DetailDialog组件未找到');
        this.$message.error('详情组件加载失败，请刷新页面重试');
        return;
      }

      // 定义题目基础信息列配置
      const basicColumns = [
        // { label: '题目ID', prop: 'id', type: 'text' },
        { label: '题目名称', prop: 'name', type: 'text', span: 3},
        { label: '分类', prop: 'categoryName', type: 'text' },
        { label: '图标', prop: 'icon', type: 'image' },
        { label: '布局视图', prop: 'view', type: 'tag', tagMap: {
          've1': { text: '列表形', type: 'primary' },
          've2': { text: '田字形', type: 'success' }
        }},
        { label: '答题方式', prop: 'answerWay', type: 'tag', tagMap: {
          'sel1': { text: '单选', type: 'primary' },
          'sel2': { text: '多选', type: 'warning' },
          'gap': { text: '填空题', type: 'info' }
        }},
        { label: '题目内容', prop: 'content', type: 'text', span: 3 },
        { label: '题目解析', prop: 'description', type: 'text', span: 3 },
        { label: '排序', prop: 'sortOrder', type: 'text' },
        { label: '状态', prop: 'isOffline', type: 'tag', tagMap: {
          0: { text: '上架', type: 'success' },
          1: { text: '下架', type: 'danger' }
        }},
        { label: '创建时间', prop: 'ctime', type: 'date' },
        { label: '更新时间', prop: 'utime', type: 'date' },
      ];

      // 构建选项卡数据
      const tabsData = [
        {
          label: '基础信息',
          name: 'basic',
          columns: basicColumns,
          data: row
        },
        {
          label: '答案列表',
          name: 'answers',
          columns: [
            { label: '答案统计', prop: 'summary', type: 'text', span: 2 },
            { label: '答案列表', prop: 'answersList', type: 'html', span: 2 }
          ],
          data: {}
        }
      ];

      this.$refs.detailDialog.openWithMultiLanguage(tabsData, {
        // enableMultiLanguage: true,
        // languageList: this.languageList,
        originalData: row
      });
    },

    // 查看答案
    async handleViewAnswers(row) {
      this.$refs.answerPanel.open(row);
      // 跳转到答案列表页面，并传递题目ID
      // this.$router.push({
      //   name: 'DAILY_QUESTION_MANAGEMENT_ANSWER_LIST',
      //   query: {
      //     questionId: row.id,
      //     questionName: row.name
      //   }
      // });
    },

    // 删除题目
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这道题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用删除接口
        await this.$get(`/question/info/delete/${row.id}`);
        this.$message.success('删除成功');
        this.getQuestionList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },

    // 状态变更
    async handleStatusChange(row) {
      const status = row.isOffline === 0 ? 1 : 0;
      const statusText = status === 1 ? '下架' : '上架';
      
      try {
        await this.$confirm(`确定要${statusText}这道题目吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        // 调用状态变更接口
        await this.$put(`/question/info/status/${row.id}`, { isOffline: status });
        this.$message.success(`${statusText}成功`);
        this.getQuestionList();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('状态变更失败:', error);
          this.$message.error('状态变更失败');
        }
      }
    },

    // 分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getQuestionList();
    },
    
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getQuestionList();
    },

    // 获取布局视图标签颜色
    getViewTag(view) {
      const tagMap = {
        've1': 'primary',
        've2': 'success'
      };
      return tagMap[view] || '';
    },

    // 获取布局视图文本
    getViewText(view) {
      const textMap = {
        've1': '列表形',
        've2': '田字形'
      };
      return textMap[view] || view;
    },

    // 获取答题方式标签颜色
    getAnswerWayTag(answerWay) {
      const tagMap = {
        'sel1': 'primary',
        'sel2': 'warning',
        'gap': 'info'
      };
      return tagMap[answerWay] || '';
    },

    // 获取答题方式文本
    getAnswerWayText(answerWay) {
      const textMap = {
        'sel1': '单选',
        'sel2': '多选',
        'gap': '填空题'
      };
      return textMap[answerWay] || answerWay;
    },

    // 重置搜索条件
    handleReset() {
      this.search = {};
      this.page.pageNo = 1;
      this.getQuestionList();
    },

    getBasicColumns() {
      return [
        { label: '题目名称', prop: 'name', type: 'text', required: true, span: 3 },
        { label: '分类', prop: 'categoryId', type: 'select', options: this.categoryList.map(item => ({ key: item.id, name: item.name })), required: true, span:3},
        { label: '展示日期', prop: 'showDate', type: 'date', required: true},
        { label: '布局视图', prop: 'view', type: 'select', options: this.VIEW_TYPE, required: true },
        { label: '答题方式', prop: 'answerWay', type: 'select', options: this.ANSWER_WAY, required: true },
        { label: '题目图标', prop: 'icon', type: 'image' },
        { label: '排序', prop: 'sortOrder', type: 'number' },
        { label: '是否下架', prop: 'isOffline', type: 'switch' },
        { label: '创建时间', prop: 'ctime', type: 'date', hide: true, addHide: true, editHide: true },
        { label: '更新时间', prop: 'utime', type: 'date', hide: true, addHide: true, editHide: true },
        { label: '题目内容', prop: 'content', type: 'richText', span: 3 },
        { label: '题目解析', prop: 'description', type: 'richText', span: 3, required: true },
      ];
    },

    formatAnswersListHTML(answers) {
      if (!answers || answers.length === 0) {
        return '<div style="text-align: center; color: #999; padding: 20px;">暂无答案数据</div>';
      }
      
      return answers.map((answer, index) => {
        const isCorrect = answer.isRight === 1;
        const statusColor = isCorrect ? '#67C23A' : '#F56C6C';
        const statusText = isCorrect ? '正确答案' : '错误答案';
        const iconHtml = answer.icon ? `<img src="${answer.icon}" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 10px;" alt="答案图标">` : '';
        
        return `
          <div style="border: 1px solid #EBEEF5; border-radius: 4px; padding: 15px; margin-bottom: 10px; background: #F9F9F9;">
            <div style="display: flex; align-items: flex-start; margin-bottom: 10px;">
              ${iconHtml}
              <div style="flex: 1;">
                <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;">
                  ${answer.name || '未命名'}
                </div>
                <div style="color: #666; font-size: 12px; margin-bottom: 5px;">
                  ID: ${answer.id} | 排序: ${answer.sortOrder || 0}
                </div>
                <div style="color: #666; font-size: 12px;">
                  ${answer.description || '暂无描述'}
                </div>
              </div>
              <div style="text-align: right;">
                <span style="display: inline-block; padding: 2px 8px; border-radius: 4px; color: white; font-size: 12px; background-color: ${statusColor};">
                  ${statusText}
                </span>
                <div style="color: #999; font-size: 11px; margin-top: 5px;">
                  ${answer.isOffline === 0 ? '上架' : '下架'}
                </div>
              </div>
            </div>
            <div style="font-size: 11px; color: #999; text-align: right;">
              创建: ${this.formatDate(answer.ctime)} | 更新: ${this.formatDate(answer.utime)}
            </div>
          </div>
        `;
      }).join('');
    },

    // 格式化展示日期
    formatShowDate(date) {
      if (!date) return '-';
      
      // 处理 20250401 格式的日期
      if (typeof date === 'string' && date.length === 8 && /^\d{8}$/.test(date)) {
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        return `${year}-${month}-${day}`;
      }
      
      // 如果是数字类型，可能是时间戳，先转换为字符串再处理
      if (typeof date === 'number') {
        const dateStr = date.toString();
        if (dateStr.length === 8 && /^\d{8}$/.test(dateStr)) {
          const year = dateStr.substring(0, 4);
          const month = dateStr.substring(4, 6);
          const day = dateStr.substring(6, 8);
          return `${year}-${month}-${day}`;
        }
      }
      
      // 其他情况直接返回原值，避免错误解析
      return date;
    }
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      .el-input {
        width: auto;
      }
      .timeblock {
        display: flex;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        .cla ::v-deep .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
        ::v-deep .el-input__inner {
          border: none !important;
          height: 38px;
        }
      }
    }
    &_Container {
      margin-top: 20px;
    }
    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
.ellipsis-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 显示的行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}


</style>